export default function Console({ lastOutput }) {
  if (!lastOutput) {
    return (
      <div className="pylab-console-empty">
        Run a cell to see output here.
      </div>
    );
  }

  const { heading, stdout, stderr, error } = lastOutput;
  const hasContent = stdout || stderr || error;

  return (
    <div className="pylab-console">
      {heading && (
        <p className="pylab-console-source">{heading}</p>
      )}
      {stdout && <pre className="pylab-stdout">{stdout}</pre>}
      {stderr && <pre className="pylab-stderr">{stderr}</pre>}
      {error && <pre className="pylab-error">{error}</pre>}
      {!hasContent && (
        <span className="pylab-output-done">Done — no output</span>
      )}
    </div>
  );
}
